import * as React from "react";
import {
  Typography,
  TypographyProps,
  TypographyTypeMap,
} from "@mui/material";
import { OverridableComponent } from "@mui/material/OverridableComponent";



const PageTypography: OverridableComponent<TypographyTypeMap> = (
  props: TypographyProps
) => {
  return <Typography {...props} />;
};

export default PageTypography;
